// deprecated
export default class FormatLinks {


    // deprecated
    static addHttps(link:string) {

        if (!link) return '';

        if (link.substr(0, 4)==='http') return link;
        return 'https://'+link;
    }



}


export function addHttps(link:string):string {

    if (!link) return '';

    // if (link.substr(0, 4)==='http') return link;

    // if already has http - do nothing
    if (link.substring(0, 4)==='http') return link;

    return 'https://'+link;
}